// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hit_summary-module__container--2TzKN{display:inline-block;font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}@media screen and (max-width: 62.5625em){.hit_summary-module__container--2TzKN{border:0;padding:0}}.hit_summary-module__content--3ljvL{display:inline;word-break:break-word}.hit_summary-module__more--P5QSM{color:#36b}.hit_summary-module__more--P5QSM:hover{cursor:pointer;text-decoration:underline}.hit_summary-module__visited--1Rfvd{color:#8b1aa8}\n", ""]);
// Exports
exports.locals = {
	"container": "hit_summary-module__container--2TzKN",
	"content": "hit_summary-module__content--3ljvL",
	"more": "hit_summary-module__more--P5QSM",
	"visited": "hit_summary-module__visited--1Rfvd"
};
module.exports = exports;
